module.exports = __webpack_public_path__ + "img/price-600x640.f66d864f.jpg";